
import tooltip from "@/components/tooltip.vue"
import { tooltipCustomStyle } from "@/utils/utils"

export default {
  components: {
    tooltip
  },
  props: {
    bill: {
      type: Object,
      default: () => {}
    },
    submit: {
      type: Object,
      default: () => {}
    },
    canSubmit: {
      type: Boolean,
      default: false
    },
    errorTipsText: {
      type: String,
      default: ""
    },
    toastInfos: {
      type: Object,
      default: () => {}
    },
    isPickup: {
      type: Boolean,
      default: false
    },
    offlinePaymentFlag: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      protocalUrl: {
        privacyProtocol: "https://711-hk.rta-os.com/d/UtWhq1euEI.html",
        protocolUrl: "https://711-hk.rta-os.com/d/26skVec3FES.html"
      }
    }
  },
  computed: {
    subtotalTip() {
      if (!this.toastInfos || !this.toastInfos.subtotalTip) return ""
      return this.toastInfos.subtotalTip.replace(
        this.toastInfos.deliveryDiffAmount,
        '<span style="font-weight: 700;font-weight: bold;">' + this.toastInfos.deliveryDiffAmount + "</span>"
      )
    },
    billText() {
      const deliveryFee = this.bill.shipping
      const packagingFee = this.bill.packaging
      const handlingFee = this.bill.baseServiceFee
      if (!this.isPickup) {
        if (deliveryFee > 0 && packagingFee > 0) {
          return `${this.$t("checkout.Including")}${this.$t("checkout.deliveryFee")} $${this.fen2Yuan(
            deliveryFee
          )} + ${this.$t("checkout.packagingHandlingFee")} $${this.fen2Yuan(packagingFee)}`
        } else if (deliveryFee > 0 && packagingFee <= 0) {
          return `${this.$t("checkout.Including")}${this.$t("checkout.deliveryFee")} $${this.fen2Yuan(deliveryFee)}`
        } else if (deliveryFee <= 0 && packagingFee > 0) {
          return `${this.$t("checkout.Including")}${this.$t("checkout.packagingHandlingFee")} $${this.fen2Yuan(
            packagingFee
          )}`
        }
      } else if (handlingFee > 0 && packagingFee > 0) {
        return this.$t("cart.handlingAndPackagingFee", {
          handlingFee: this.fen2Yuan(handlingFee),
          packagingFee: this.fen2Yuan(packagingFee)
        })
      } else if (handlingFee > 0 && packagingFee <= 0) {
        return this.$t("cart.onlyHandlingFee", { handlingFee: this.fen2Yuan(handlingFee) })
      } else if (handlingFee <= 0 && packagingFee > 0) {
        return this.$t("cart.onlyPackagingFee", { packagingFee: this.fen2Yuan(packagingFee) })
      }
      return ""
    },
    // 结合了前端和后端的判断
    payIsDisabled() {
      return this.submit.disabled || !this.canSubmit
    }
  },
  methods: {
    getFeeMsgContent(bill) {
      const { billItemVOList = [], remarkList = [] } = bill
      if (billItemVOList && billItemVOList.length) {
        const result = billItemVOList.map(
          (item, index) => `<div style="display: flex;justify-content: space-between;margin-top: ${
            index === 0 ? "0" : "0.16rem"
          };">
            <span>${item.name}</span>
            <span>${item.positive ? "" : "-"}$${this.fen2Yuan(item.value)}</span></div>`
        )
        return result
      }
      return remarkList || []
    },
    tooltipCustomStyle(index) {
      return tooltipCustomStyle(index)
    },
    fen2Yuan(num) {
      if (isNaN(num)) return ""
      num = Number(num)
      return (num / 100).toFixed(2)
    },
    goDfiPage() {
      const lang = this.$i18n.locale
      if (lang === "zh_HK") {
        window.open("https://www.dfiretailgroup.com/zh-HK")
      } else {
        window.open("https://www.dfiretailgroup.com/en")
      }
    },
    goTerms() {
      const lang = this.$i18n.locale
      if (lang === "zh_HK") {
        window.open("https://www.yuurewards.com/zh-hant/terms-and-conditions")
      } else {
        window.open("https://www.yuurewards.com/en/terms-and-conditions")
      }
    },
    goPolicy() {
      const lang = this.$i18n.locale
      if (lang === "zh_HK") {
        window.open("https://www.yuurewards.com/zh-hant/privacy-policy")
      } else {
        window.open("https://www.yuurewards.com/en/privacy-policy")
      }
    },
    handleJump(type) {
      switch (type) {
        case "terms":
          this.goTerms()
          break
        case "policy":
          this.goPolicy()
          break
        case "dfi":
          this.goDfiPage()
          break
        default:
          break
      }
    },
    handleSubmit() {
      if (this.payIsDisabled) return
      this.$emit("submit")
    },
    handlePlaceOrderSubmit() {
      this.$emit("offlineSubmit")
    }
  }
}
